import { trackSelfDescribingEvent } from '@snowplow/browser-tracker';
import { snakeCase } from 'change-case';

const trackButtonClick = ({ label, type, state }) => {
  trackSelfDescribingEvent({
    event: {
      schema: 'iglu:com.snowplowanalytics.snowplow/button_click/jsonschema/1-0-0',
      data: {
        event_name: 'button_click',
        button_type: label ? snakeCase(label).toLowerCase() : null,
        type,
        state,
      },
    },
  });
};

export default trackButtonClick;
